/* Auraline — interactividad */
(function() {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.aur-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('aur-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aur-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function(el) { observer.observe(el); });
  }

  function initFAQ() {
    var items = document.querySelectorAll('.aur-faq-item');
    if (!items.length) return;
    items.forEach(function(item) {
      var q = item.querySelector('.aur-faq-q');
      if (!q) return;
      q.addEventListener('click', function() {
        var open = item.classList.contains('is-open');
        items.forEach(function(other) { other.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
  }

  function initOilTabs() {
    var tabs = document.querySelectorAll('.aur-oils-tab');
    var panels = document.querySelectorAll('.aur-oil-panel');
    if (!tabs.length || !panels.length) return;
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-target');
        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = document.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-count-up]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.textContent = el.getAttribute('data-count-up'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count-up'));
        var duration = 1600;
        var start = performance.now();
        function tick(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var val = target * eased;
          el.textContent = target % 1 === 0 ? Math.floor(val) : val.toFixed(1);
          if (progress < 1) requestAnimationFrame(tick);
          else el.textContent = target % 1 === 0 ? target : target.toFixed(1);
        }
        requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function(el) { observer.observe(el); });
  }

  function initProductQty() {
    var qtyEls = document.querySelectorAll('.aur-product-qty');
    qtyEls.forEach(function(qty) {
      var input = qty.querySelector('input');
      if (!input) return;
      var minus = qty.querySelector('[data-qty-action="minus"]');
      var plus = qty.querySelector('[data-qty-action="plus"]');
      if (minus) minus.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change'));
      });
      if (plus) plus.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  function initProductGallery() {
    var thumbs = document.querySelectorAll('.aur-product-thumb');
    var mainImg = document.querySelector('.aur-product-main-img img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        mainImg.src = src;
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initProductVariants() {
    var form = document.querySelector('[data-aur-product-form]');
    if (!form) return;
    var data = form.querySelector('[data-aur-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch(e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-aur-price]');
    var compareEl = document.querySelector('[data-aur-compare]');
    var addBtn = form.querySelector('[data-aur-add]');
    var pickers = form.querySelectorAll('[data-aur-picker]');

    function getSelection() {
      var sel = [];
      pickers.forEach(function(picker) {
        var checked = picker.querySelector('input:checked');
        if (checked) sel.push(checked.value);
        var labelEl = picker.querySelector('[data-aur-picker-current]');
        if (labelEl && checked) labelEl.textContent = checked.value;
      });
      return sel;
    }
    function update() {
      var sel = getSelection();
      var match = variants.find(function(v) {
        return v.options.length === sel.length && v.options.every(function(o, i) { return o === sel[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price !== match.price) {
          compareEl.textContent = match.compare_at_price;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-text-add') || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-text-sold') || 'Sold out';
        }
      }
    }
    pickers.forEach(function(picker) {
      picker.addEventListener('change', update);
    });
    update();
  }

  function initProductSwipe() {
    var wrap = document.querySelector('[data-aur-swipe]');
    if (!wrap) return;
    var track = wrap.querySelector('.aur-product-swipe-track');
    var dots = wrap.querySelectorAll('.aur-swipe-dot');
    if (!track || !dots.length) return;

    function updateDots() {
      var slideWidth = track.clientWidth;
      var idx = Math.round(track.scrollLeft / slideWidth);
      idx = Math.max(0, Math.min(dots.length - 1, idx));
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
    }
    var ticking = false;
    track.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() { updateDots(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  function initCarousels() {
    var carousels = document.querySelectorAll('[data-aur-carousel]');
    if (!carousels.length) return;
    carousels.forEach(function(carousel) {
      var row = carousel.querySelector('.aur-carousel-row');
      var dots = carousel.querySelectorAll('.aur-carousel-dot');
      var prev = carousel.querySelector('[data-aur-carousel-prev]');
      var next = carousel.querySelector('[data-aur-carousel-next]');
      if (!row) return;

      function getItemWidth() {
        var first = row.querySelector('.aur-carousel-item');
        if (!first) return row.clientWidth;
        var style = window.getComputedStyle(row);
        var gap = parseInt(style.gap, 10) || 14;
        return first.getBoundingClientRect().width + gap;
      }
      function updateDots() {
        if (!dots.length) return;
        var iw = getItemWidth();
        var idx = Math.round(row.scrollLeft / iw);
        idx = Math.max(0, Math.min(dots.length - 1, idx));
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      }
      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = row.scrollLeft <= 4;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }
      var ticking = false;
      row.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(function() { updateDots(); updateArrows(); ticking = false; });
          ticking = true;
        }
      }, { passive: true });

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          row.scrollTo({ left: i * getItemWidth(), behavior: 'smooth' });
        });
      });
      if (prev) prev.addEventListener('click', function() {
        row.scrollBy({ left: -getItemWidth(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        row.scrollBy({ left: getItemWidth(), behavior: 'smooth' });
      });
      updateDots(); updateArrows();
    });
  }

  function initShowMore() {
    var groups = document.querySelectorAll('[data-aur-show-more]');
    groups.forEach(function(group) {
      var hiddenItems = group.querySelectorAll('[data-aur-hidden-item]');
      var trigger = group.querySelector('[data-aur-show-more-trigger]');
      if (!hiddenItems.length || !trigger) return;
      trigger.addEventListener('click', function() {
        hiddenItems.forEach(function(it) { it.style.display = ''; it.classList.add('is-revealed'); });
        trigger.style.display = 'none';
      });
    });
  }

  function init() {
    initReveals();
    initFAQ();
    initOilTabs();
    initCountUp();
    initProductQty();
    initProductGallery();
    initProductVariants();
    initProductSwipe();
    initCarousels();
    initShowMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
